import Reveal from '@/components/base/Reveal';
import { graphicUnivers } from '@/mocks/brand';

const photoRules = [
  {
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.39.37-1.jpeg',
    label: 'Soudure en atelier',
    note: 'Geste réel, arc visible, cadrage serré',
  },
  {
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.26-1.jpeg',
    label: 'Structure métallique',
    note: 'Géométrie, lignes de force, contre-jour maîtrisé',
  },
  {
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-07-at-13.05.04.png',
    label: 'Équipe en intervention',
    note: 'EPI complets, pas de mise en scène',
  },
];

export default function GraphicUniverse() {
  return (
    <section id="univers" className="scroll-mt-32 border-t border-background-200 bg-background-100 py-16 md:py-24">
      <div className="container-wide">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <Reveal>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-accent-500" />
              <span className="label-mono text-primary-600">04 — L’univers graphique</span>
            </div>
            <h2 className="display-title mt-5 text-4xl text-foreground-950 md:text-5xl">
              Le vocabulaire
              <br />
              de la construction métallique
            </h2>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
              Filets, cotes, trames de plan : la marque emprunte sa grammaire aux documents
              techniques. Rien de décoratif — chaque élément a une fonction d’orientation.
            </p>

            <div className="mt-8 overflow-hidden rounded-lg border border-background-300 bg-background-50">
              <div className="relative flex h-[180px] items-center justify-center overflow-hidden">
                <div className="absolute inset-0 blueprint-grid opacity-70" />
                <div className="absolute inset-0 hatch-lines opacity-60" />
                <div className="relative flex items-center gap-4">
                  <span className="flex h-16 w-16 items-center justify-center border-2 border-primary-500 bg-background-50">
                    <i className="ri-crop-2-line text-2xl text-primary-500" />
                  </span>
                  <div className="space-y-2">
                    <span className="block h-2 w-24 bg-primary-500" />
                    <span className="block h-2 w-16 bg-accent-500" />
                    <span className="block h-1 w-20 bg-secondary-500" />
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between border-t border-background-200 px-4 py-3">
                <span className="label-mono text-foreground-500">Trame & hachures</span>
                <span className="font-label text-[10px] tracking-[0.14em] text-foreground-400">
                  opacité ≤ 10 %
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="grid gap-px overflow-hidden rounded-lg bg-background-200">
              {graphicUnivers.map((item) => (
                <div key={item.title} className="flex items-start gap-4 bg-background-50 p-5 md:p-6">
                  <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md border border-primary-200 bg-primary-50 text-primary-600">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading text-lg font-semibold uppercase leading-tight text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 grid grid-cols-3 gap-3">
              {photoRules.map((photo, index) => (
                <Reveal key={photo.label} delay={index * 80}>
                  <figure className="group">
                    <div className="relative h-[124px] w-full overflow-hidden rounded-md bg-foreground-950">
                      <img
                        src={photo.image}
                        alt={`${photo.label} — direction photographique SGSCTIC`}
                        title={`SGSCTIC — ${photo.label}`}
                        className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      />
                      <span className="absolute inset-x-0 bottom-0 h-1 bg-accent-500" />
                    </div>
                    <figcaption className="mt-2">
                      <p className="font-heading text-sm font-semibold uppercase leading-tight text-foreground-950">
                        {photo.label}
                      </p>
                      <p className="mt-0.5 text-[10px] leading-relaxed text-foreground-500">
                        {photo.note}
                      </p>
                    </figcaption>
                  </figure>
                </Reveal>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}